<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-4 col-sm-6">
          <h5>Hostel</h5>
        </div>
        <div class="col-8 col-sm-6 text-right">
          <div class="d-inline-flex flex-row">
            <div class="mr-2">
              <hostel-add-modal @created="handleCreated"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <hostel-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable"/>
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>

  </div>
</template>

<script>
import hostelAddModal from '@/components/hostel/manage/hostel/add'
import HostelTable from '@/components/hostel/manage/hostel/index'
export default {
  components: {
    hostelAddModal,
    HostelTable,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('hostels', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  mounted() {
    this.getHostels()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      selectedRowKeys: [],
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getHostels: function() {
      this.selectedRowKeys = []
      this.loading = true
      this.$http.get('/api/hostel', {
        params: {
          limit: this.pageSize,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getHostels()
    },
    onChange(current) {
      this.current = current
      this.getHostels()
    },
    handleUpdateTable: function() {
      this.getHostels()
    },
    handleCreated: function() {
      this.getHostels()
    },
  },
}
</script>
<style>
.error { padding: 25px 5px; }
</style>
